/**
 * EmbedRestrictedGuard — blocks billing / plan surfaces (Upgrade / Usage)
 * for partner-SSO (embedded iframe) sessions.
 *
 * The matching navbar buttons are already hidden in embed mode
 * (`Navbar.jsx:_showNavbarPlanActions` → `isPartnerSsoSession()`), but the
 * routes themselves stay reachable by typing the URL. This guard is the
 * hard backstop: an embedded user who navigates straight to `/shop`,
 * `/shop/addons`, or `/usage` is bounced to the embed dashboard instead.
 *
 * Why partner-SSO users are blocked: their plan is owned and paid by the
 * partner, not the end user — self-serve upgrade and usage views don't
 * apply inside the iframe.
 *
 * Detection uses `useIsEmbedMode()` (the route-tree signal OR the
 * `flow: "partner_sso"` JWT claim), so it works even though these routes
 * sit OUTSIDE the `/embed/*` subtree.
 */
import { Navigate } from "react-router-dom";
import useIsEmbedMode from "../../hooks/useIsEmbedMode";

const EmbedRestrictedGuard = ({ children }) => {
  const isEmbed = useIsEmbedMode();
  if (isEmbed) {
    return <Navigate to="/embed/dashboard" replace />;
  }
  return children;
};

export default EmbedRestrictedGuard;
